import React from 'react';
import { useNavigate } from 'react-router-dom';
import PartnerRegistration from './components/Registeration';

function SignUp() {
  const navigate = useNavigate();

  return (
    <div className="w-full max-w-md bg-white shadow-2xl rounded-3xl p-5 md:p-6 text-gray-900 border border-gray-100 flex flex-col mx-auto max-h-[85vh] overflow-hidden animate-slide-in-right">
      
      {/* Header Tabs */}
      <div className="flex border-b border-gray-200 mb-4 shrink-0">
        <button 
          type="button" 
          onClick={() => navigate('/login')} 
          className="flex-1 py-2.5 text-center font-semibold text-gray-500 hover:text-gray-700 transition-colors cursor-pointer"
        >
          Login
        </button>
        <button 
          type="button" 
          className="flex-1 py-2.5 text-center font-bold text-[#067978] border-b-2 border-[#067978] cursor-pointer"
        >
          Register
        </button>
      </div>

      <div className="flex-1 flex flex-col min-h-0 overflow-hidden">
        <PartnerRegistration />
      </div>
    </div>
  );
}

export default SignUp;